/* La Peau — animaciones de la barra de obsequios (snippets/lp-gift-tracker.liquid).
   El Liquid ya pinta el estado; aquí solo: chip "n/3" del encabezado, círculo que late, tarjeta
   "¡Desbloqueaste…!" y aviso flotante al ganar o perder un obsequio, y la hoja "Ver ciudades". */
(function () {
  var KEY = 'lpGtWon', UNLOCK_KEY = 'lpGtUnlock';
  var GIFT = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3.5" y="9" width="17" height="11" rx="1.5"/><path d="M2.5 9h19v-3h-19zM12 6v14"/><path d="M12 6c-1.5-3-5-3.5-5-1.2C7 6 9.5 6 12 6Zm0 0c1.5-3 5-3.5 5-1.2C17 6 14.5 6 12 6Z"/></svg>';
  var toastEl = null, toastTimer = null;

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'lp-gt-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2600);
  }

  function unlockCard(n, name) {
    var art = n === 2 ? 'tu' : n === 1 ? 'tus' : 'un';
    var d = document.createElement('div');
    d.className = 'lp-gt__unlock';
    d.innerHTML = GIFT + '<span><b></b><br>Lo agregamos gratis a tu pedido.</span>';
    d.querySelector('b').textContent = '¡Desbloqueaste ' + art + ' ' + name.toLowerCase() + '!';
    return d;
  }

  /* El contador del carrito cuenta solo productos, como en el demo: los obsequios no suman. */
  function syncCount(items) {
    document.querySelectorAll('hdt-cart-count').forEach(function (el) {
      if (el.textContent.trim() !== String(items)) el.textContent = items;
    });
  }

  function syncChips(won, total) {
    document.querySelectorAll('[data-lp-gt-chip]').forEach(function (chip) {
      chip.dataset.n = won;
      var label = chip.querySelector('[data-lp-gt-chip-n]');
      if (label) label.textContent = won + '/' + total;
    });
  }

  function process(el) {
    var won = Number(el.dataset.won || 0), total = Number(el.dataset.total || 0);
    var names = (el.dataset.names || '').split('|');
    syncCount(Number(el.dataset.items || 0));
    if (el.dataset.lpGtSeen === String(won)) return;
    el.dataset.lpGtSeen = String(won);
    syncChips(won, total);

    var prevRaw = store(KEY);
    var prev = prevRaw === null ? won : Number(prevRaw);
    store(KEY, String(won));
    var slot = el.querySelector('[data-lp-gt-unlock]');

    if (won > prev) {
      var mark = el.querySelector('[data-lp-gt-mark="' + won + '"]');
      if (mark) mark.classList.add('is-pop');
      if (slot) slot.replaceChildren(unlockCard(won, names[won - 1] || ''));
      store(UNLOCK_KEY, JSON.stringify({ n: won, at: Date.now() }));
      toast('Obsequio desbloqueado: ' + (names[won - 1] || ''));
    } else if (won < prev) {
      store(UNLOCK_KEY, '');
      toast('Tu carrito bajó del mínimo: se retiró ' + (names[prev - 1] || '').toLowerCase());
    } else if (slot && won > 0) {
      // El carrito se vuelve a pintar varias veces seguidas (el obsequio entra en una segunda pasada):
      // se conserva la tarjeta del último desbloqueo durante unos segundos, sin repetir la animación.
      try {
        var last = JSON.parse(store(UNLOCK_KEY) || 'null');
        if (last && last.n === won && Date.now() - last.at < 15000) {
          var card = unlockCard(won, names[won - 1] || '');
          card.style.animation = 'none';
          slot.replaceChildren(card);
        }
      } catch (e) { /* sin tarjeta */ }
    }
  }

  function scan() { document.querySelectorAll('[data-lp-gt]').forEach(process); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lp-gt-ship-info]');
    if (!btn || !window.LpModal) return;
    var scope = btn.closest('[data-lp-gt], [data-lp-ship]');
    var tpl = scope && scope.querySelector('template[data-lp-gt-ship-template]');
    if (tpl) { e.preventDefault(); window.LpModal.open(tpl.innerHTML, { narrow: true }); }
  });

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
